{
  "backToPost": "Back to the post",
  "needsApproval": "Needs approval",
  "postCancelled": "This event was cancelled. Registrants were notified.",
  "summary": "Summary",
  "status_pending": "Pending",
  "status_confirmed": "Confirmed",
  "status_waitlisted": "Waitlisted",
  "status_declined": "Declined",
  "status_cancelled": "Cancelled",
  "filter_active": "Active",
  "filter_pending": "Pending",
  "filter_confirmed": "Confirmed",
  "filter_waitlisted": "Waitlist",
  "filter_declined": "Declined",
  "filter_cancelled": "Cancelled",
  "filter_all": "All",
  "checkedIn": "Checked in",
  "notCheckedIn": "Not checked in yet",
  "anyAttendance": "Any attendance",
  "seatsTotal": "Slots taken",
  "sessionCancelled": "cancelled",
  "waitlistN": "{count} waiting",
  "search": "Search name, mobile or ticket",
  "session": "Date / time slot",
  "allSessions": "All dates",
  "chooseSession": "Choose a date",
  "showing": "Showing {count} of {total}",
  "empty": "No one has registered yet",
  "emptyBody": "Share the post's link on your Facebook page so residents register in the app.",
  "emptyFilter": "No registrants match these filters",
  "plusCompanions": "+{count} companions",
  "registeredOn": "Registered {date}",
  "registeredAt": "Registered",
  "walkIn": "Walk-in",
  "checkedInAt": "Checked in {time}",
  "decide": "Approve or decline",
  "checkIn": "Check in",
  "undoCheckIn": "Undo check-in",
  "cancelReg": "Cancel",
  "confirmCancel": "Cancel {name}'s registration? They will be notified, and the next person on the waitlist moves up.",
  "checkedInToast": "{name} checked in.",
  "undoneToast": "Check-in undone for {name}.",
  "cancelledToast": "{name}'s registration was cancelled.",
  "decisionTitle": "Registration of {name}",
  "noteToRegistrant": "Note to the registrant",
  "noteHint": "Optional. They see this with your decision, e.g. what to bring or why it was declined.",
  "approve": "Approve",
  "decline": "Decline",
  "approvedToast": "{name} was approved.",
  "declinedToast": "{name} was declined.",
  "addWalkIn": "Add walk-in",
  "walkInLead": "For someone registering at the venue or by phone. No account needed; they're confirmed right away.",
  "companions": "Companions",
  "checkInNow": "Check them in now",
  "overrideCapacity": "Add even if full",
  "noLimit": "no limit",
  "seatsLeft": "{count} slots left",
  "walkInAdded": "{name} was added.",
  "sendUpdate": "Send update",
  "sendUpdateLead": "Everyone registered gets this as a notification in the app, e.g. a venue change reminder or what to bring.",
  "message": "Message",
  "charCount": "{count} / 1000",
  "sendTo": "Send to",
  "alsoSms": "Also send as SMS",
  "smsNotConfigured": "SMS isn't set up for this LGU yet. The update goes by app notification only.",
  "messageTooShort": "Write a message of at least 3 characters.",
  "messageSent": "Update sent to {count} registrants.",
  "messageSentSms": "Update sent to {count} registrants ({sms} by SMS).",
  "messagesSent": "Updates sent",
  "recipients": "{count} recipients",
  "smsCount": "{count} SMS",
  "ticket": "Ticket",
  "waitlistPosition": "Waitlist position",
  "officeNote": "Office note",
  "sex_female": "Female",
  "sex_male": "Male",
  "sex_prefer_not_to_say": "Prefer not to say"
}
